import type { FunctionComponent } from "react";
import SyncLoader from "react-spinners/SyncLoader";

import { LoadingContainer } from "./loading.styles";

interface LoadingProps {
	message?: string;
}

const Loading: FunctionComponent<LoadingProps> = ({ message }) => {
	return (
		<LoadingContainer>
			{message && <p>{message}</p>}
			<SyncLoader size={20} />
		</LoadingContainer>
	);
};

export default Loading;
